import React from 'react';
import { css } from 'glamor';
import { useSelector } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import LogoIcon from '../images/logo.png';
import HomeIcon from '../images/home.png';
import InventoryIcon from '../images/inventory.png';
import MarketIcon from '../images/market.png';
import ContactsIcon from '../images/contacts.png';
import { UserService } from '../UserService';
import { amdinAccount } from '../config/config';
import { Animated } from 'react-animated-css';
import { setActiveTab } from '../GlobalState/MenuReducer';
import { storeAppDispatch } from '../GlobalState/Store';
import uiVersion from '../config/version.json';
import './Menu.scss';


export const Menu = (props) => {
    const UserState = useSelector((store) => store.user);
    const MenuState = useSelector((store) => store.menu);
    const activeTab = MenuState.activeTab;

    const disabledStyle = css({
      opacity: 0.5
    });

    const myStyle = (btnId) => {
      if (btnId === activeTab) return ({ borderBottom: '6px solid red' });
      return ({});
    };

    const display_login_keychain = () => {
      if (window.hive_keychain) {
        let keychain = window.hive_keychain
        keychain.requestHandshake(() => {
          // setState({ loginType: "keychain" });
        });
      } else {
        // setState({ error: "You do not have hive keychain installed" });
      }
    };

    return (
      <>
        <Animated animationIn="fadeInUp" animationOut="slideOutLeft" animationInDuration={500} animationInDelay={50} animationOutDuration={3000} isVisible={true}>
          <nav id="menu" className="d-flex justify-content-between align-items-center px-5">
            {
              (!UserService.isLogged()) ?
                <Redirect to="/" /> :
                <></>
            }
            <div className="d-flex align-items-center">
              <Link to='/'>
                <img src={LogoIcon} alt="LogoIcon" width="42" />
              </Link>
              <div id="username" className="ms-4 pl-3">
                {UserState.isLogged ?
                  <a href={`https://peakd.com/@${UserState.username}`} target="_blank" rel="noreferrer">@{UserState.username}</a>
                  : '' /*- Wallet: ${UserState.balance}`*/
                }
              </div>
            </div>
            <div id="play-btn-wrap" className="flex" onClick={() => window.open('https://play.crypto-shots.com', '_blank')}>
              <img
                className="btn-item cool-btn"
                src="https://files.peakd.com/file/peakd-hive/cryptoshots.nft/23tc5wBEnuQHxrCQsM4qCwH1S1tEVGiZR71w1cHfW2AzqdeiD3NqAWi5okejCKKHRbR8U.png"
                alt="play btn"
              />
            </div>
            <div id="website-btn-wrap" className="flex" onClick={() => window.open('https://crypto-shots.com', '_blank')}>
              <img
                className="btn-item cool-btn"
                style={{ marginLeft: '-220px' }}
                src="https://files.peakd.com/file/peakd-hive/cryptoshots.nft/23tmWYCJSJLsfiQYNogG5ZoFSdorwn8wYh1WYQSxjcDA1WcQLoV8NhcKPAG9918XUhSFQ.png"
                alt="play btn"
              />
            </div>
            <div id="buttons-wrap" className="d-flex">
              <Link
                onClick={() => storeAppDispatch(setActiveTab({ activeTab: 0 }))}
                to="/" className={`btn-item text-white`} style={{...myStyle(0)}}
              >
                <sub>Home &nbsp; &nbsp;</sub>
                <img
                  className="home-btn"
                  src={HomeIcon}
                  alt="home"
                />
              </Link>
              <Link
                onClick={() => UserState.isLogged && storeAppDispatch(setActiveTab({ activeTab: 1 }))}
                to="/home" className={`${UserState.isLogged ? '' : disabledStyle} btn-item text-white`} style={{...myStyle(1)}}
                >
                  <sub>Your NFTs &nbsp; &nbsp;</sub>
                  <img
                    className="home-btn"
                    src={InventoryIcon}
                    alt="home"
                  />
              </Link>
              <Link
                onClick={() => UserState.isLogged && storeAppDispatch(setActiveTab({ activeTab: 2 }))}
                to="/marketplace" className={`${UserState.isLogged ? '' : disabledStyle} btn-item text-white`} style={{...myStyle(2)}}
                >
                  <sub>Buy/Sell &nbsp; &nbsp;</sub>
                  <img
                    className="home-btn"
                    src={MarketIcon}
                    alt="home"
                  />
              </Link>
              <Link
                onClick={() => storeAppDispatch(setActiveTab({ activeTab: 3 }))} to='/about-us' className={`btn-item text-white`} style={{...myStyle(3)}}
                >
                  <sub>About us &nbsp; &nbsp;</sub>
                  <img
                    className="home-btn"
                    src={ContactsIcon}
                    alt="home"
                  />
              </Link>
              {
                UserState.isLogged && UserState.username === amdinAccount &&
                <Link
                  onClick={() => storeAppDispatch(setActiveTab({ activeTab: 4 }))}
                  to="/administrator" className={`${UserState.isLogged ? '' : disabledStyle} btn-item text-white`} style={{...myStyle(4)}}
                  >
                    <sub>Home &nbsp; &nbsp;</sub>
                  <img
                    className="home-btn"
                    src={HomeIcon}
                    alt="home"
                  />
                    Administrator
                </Link>
              }
            </div>
            <div className="text-white"><sub>v{uiVersion.HIVE_MARKETPLACE_VERSION}</sub></div>
          </nav>
        </Animated>
      </>
    );
}
